import WarningRounded from '@mui/icons-material/WarningRounded';
import { SxProps, Theme } from '@mui/material/styles';
import Tooltip from '@mui/material/Tooltip';
import { t } from 'i18next';

interface UomMismatchIndicatorProps {
  sx?: SxProps<Theme>;
  /** The expected UOM from the job (for load-level tooltip) */
  expectedUom?: string;
  /** The actual UOM from the load (for load-level tooltip) */
  actualUom?: string;
}

/**
 * Caution flag indicator for UOM mismatches.
 * Shows a warning icon with tooltip explaining the mismatch.
 *
 * - For job rows: Pass no UOM props to show generic "one or more loads" message
 * - For load rows: Pass expectedUom and actualUom to show specific values
 */
export default function UomMismatchIndicator({
  sx,
  expectedUom,
  actualUom,
}: UomMismatchIndicatorProps) {
  const tooltipMessage =
    expectedUom && actualUom
      ? t('uom_mismatch.load_warning', { loadUom: actualUom, jobUom: expectedUom })
      : t('uom_mismatch.job_warning');

  return (
    <Tooltip title={tooltipMessage}>
      <WarningRounded
        sx={[
          (theme) => ({
            color: theme.brandV2.colors.treadOrange,
            height: '16px',
            width: '16px',
          }),
          ...(Array.isArray(sx) ? sx : [sx]),
        ]}
      />
    </Tooltip>
  );
}
